export default __webpack_public_path__ + "static/media/xpensityv1-sm.7df2e5e2.webp";